/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";

import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VERIFY_PHONE } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IVerifyOTPMethods extends IPluginMethodMap {
  getVerifyOTP(args: any): Promise<any>;
}

export interface verifyOTPProps {
  otp?: string;
}

export class VerifyOTPService implements IAgentPlugin {
  readonly methods: IVerifyOTPMethods;

  constructor() {
    this.methods = {
      getVerifyOTP: this.getVerifyOTP.bind(this),
    };
  }

  async getVerifyOTP(args: verifyOTPProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: VERIFY_PHONE,
          variables: {
            otp: args?.otp,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.verifyMobileNo) {
          return {
            data: res?.data?.verifyMobileNo?.message,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
